import { Label } from 'semantic-ui-react';

export default Label;